interface Props {
  eyebrow?: string;
  title: string;
  desc?: string;
  center?: boolean;
}

export default function SectionHeading({ eyebrow, title, desc, center }: Props) {
  return (
    <div className={`max-w-2xl ${center ? "mx-auto text-center" : ""}`}>
      {eyebrow && (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
          <i className="ri-sparkling-2-line text-sm"></i>
          {eyebrow}
        </span>
      )}
      <h2 className="mt-3 font-heading text-2xl leading-tight text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {desc && <p className="mt-3 text-sm leading-relaxed text-foreground-600">{desc}</p>}
    </div>
  );
}